import Modal from 'modules/app-core/modal'
import EmpTerminationContainer from './EmpTerminationContainer/EmpTerminationContainer'

export default Modal.containers.Modal({
  content: {
    position: 'top',
    styles: {
      margin: '50px 0 0 0',
    },
  },
  overlay: {
    hideCloseButton: false,
    routeOnHide: false,
  },
})(EmpTerminationContainer)
